import { styled } from '@mui/system'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { LocalizedLink as Link } from "gatsby-theme-i18n"
import { withPrefix } from 'gatsby'

const RootDiv = styled('div')({
  position: 'relative',
  width: "160px",
  height: "90px",
  margin: "10px 0 0 0px"
})

const DivName = styled('div')({
  position: "absolute",
  width: "100%",
  height: "100%",
  top: "0px",
  left: "0px",
  padding: "38px 0 12px 20px",
  fontSize: "12px",
  textTransform: "uppercase",
  fontWeight: "bold",
  zIndex: "11000",
  opacity: "0",
  transition: "0.2s",
  cursor: "pointer",
  overflow: "hidden",
  backgroundColor: "#46d2ff",
  '&:hover, &.Mui-focusVisible':{
    opacity: "1",
  }
})

const Square = styled('div')({
  width: "16px",
  height: "16px",
  position: "absolute",
  top: "56px",
  left: "0px",
  backgroundColor: "#E6142D",
})


export default function ListPortrait ({portrait, handleClickItemLink, inPortrait}) {
  const intl = useIntl()
  
	const LinkDiv = styled((inPortrait) ? 'div' : Link)({
    textDecoration: "none",
    color: 'black',
	})

	const handleClick = () => {
		handleClickItemLink(portrait);
	}

	const LinkDivProps = (inPortrait) ?
		  {onClick: handleClick}
	  :
	  	{to: `/portrait/${portrait.slug}`};

  return (
    <RootDiv>
      <LinkDiv {...LinkDivProps}>
        <Square/>
        <img src={withPrefix(`/images/miniature/` + portrait.miniature)} alt={portrait.translations.find((trans) => (trans.lang === intl.locale)).title + "link"}/>
        <DivName>
          {portrait.translations.find((trans) => (trans.lang === intl.locale)).title}
        </DivName>
      </LinkDiv>
    </RootDiv>
  )
}